// QuestionVAS.js
import React from "react";
import { QuestionTextModel, QuestionFactory, Serializer } from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "vas";
let isRegistered = false;

/* =========================================================
   QUESTION MODEL - Simple wrapper for text input
========================================================= */
class QuestionVASModel extends QuestionTextModel {
  constructor(name) {
    super(name);

    // Default properties for VAS
    this.inputType = "text";
    this.placeholder = "Enter value";

    // You can add VAS-specific defaults if needed
    this.maxLength = 100;
  }

  getType() {
    return QUESTION_TYPE;
  }

  // Add VAS-specific properties if needed in future
  get vasType() {
    return this.getPropertyValue("vasType", "numeric");
  }

  set vasType(val) {
    this.setPropertyValue("vasType", val);
  }
}

/* =========================================================
   REACT RENDERER - Simple text input
========================================================= */
class SurveyQuestionVAS extends SurveyQuestionElementBase {
  get question() {
    return this.props.question;
  }

  handleChange = (e) => {
    this.question.value = e.target.value || null;
  };

  handleBlur = (e) => {
    // FIX: Pass the event object
    this.question.onBlur(e);
  };

  handleFocus = (e) => {
    // FIX: Pass the event object
    this.question.onFocus(e);
  };

  renderElement() {
    const q = this.question;
    const value = q.value ?? "";

    return (
      <input
        type="text"
        id={q.id}
        name={q.name}
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        placeholder={q.placeholder}
        disabled={q.isReadOnly}
        required={q.isRequired}
        maxLength={q.maxLength}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "8px 12px",
          borderRadius: "4px",
          border:
            q.errors.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
          backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
          fontSize: "14px",
          lineHeight: "1.5",
          transition: "border-color 0.15s ease-in-out",
        }}
        className={q.cssClasses?.root}
      />
    );
  }
}

/* =========================================================
   REGISTRATION
========================================================= */
export function registerVASQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  // Register with Serializer - inherits all text properties
  Serializer.addClass(
    QUESTION_TYPE,
    [], // No additional properties needed for now
    () => new QuestionVASModel(""),
    "text" // Inherit from text question
  );

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionVASModel(name)
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) =>
    React.createElement(SurveyQuestionVAS, props)
  );
}

// Auto-register
registerVASQuestion();

export default QuestionVASModel;
